__turbopack_context__.v({
  "circle": "style-module-scss-module__ZuPnkq__circle",
  "content": "style-module-scss-module__ZuPnkq__content",
  "ctaDotIcon": "style-module-scss-module__ZuPnkq__ctaDotIcon",
  "curvedContainer": "style-module-scss-module__ZuPnkq__curvedContainer",
  "curvedText": "style-module-scss-module__ZuPnkq__curvedText",
  "curvedWrapper": "style-module-scss-module__ZuPnkq__curvedWrapper",
  "dot-icon-animation": "style-module-scss-module__ZuPnkq__dot-icon-animation",
  "video": "style-module-scss-module__ZuPnkq__video",
  "videoWrapper": "style-module-scss-module__ZuPnkq__videoWrapper",
  "wrapper": "style-module-scss-module__ZuPnkq__wrapper",
});
